import api from '@/api/api'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const LOAD_BATCH = 'LOAD_BATCH'
export const LOAD_DADOS = 'LOAD_DADOS'
export const RESET_STATE = 'RESET_STATE'
export const SET_FILTRO_DATA_INICIAL = 'SET_FILTRO_DATA_INICIAL'
export const SET_FILTRO_DATA_FINAL = 'SET_FILTRO_DATA_FINAL'

const getDefaultState = () => {
  return {
    ready: false,
    relatorio: [],
    dadosExportacao: null,
    filtrosData: {
      data_inicial: null,
      data_final: null,
    },
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_FILTRO_DATA_INICIAL] (state, data) {
    state.filtrosData.data_inicial = data
  },
  [SET_FILTRO_DATA_FINAL] (state, data) {
    state.filtrosData.data_final = data
  },
}

const actions = {
  async [BOOTSTRAP] ({ dispatch, commit, state }, { data_inicial, data_final, relatorio, tipo, parametros }) {
    commit(SET_STATE, { ready: false, relatorio: [] })
    commit(SET_FILTRO_DATA_INICIAL, data_inicial)
    commit(SET_FILTRO_DATA_FINAL, data_final)

    const hasValidParams = parametros && typeof parametros === 'object' && Object.keys(parametros).length > 0
    await dispatch(LOAD_BATCH, {
      data_inicial,
      data_final,
      relatorio,
      ...(hasValidParams && { parametros }),
    })

    commit(SET_STATE, { ready: true })
  },
  async [LOAD_BATCH] ({ dispatch, commit }, { data_inicial, data_final, relatorio, parametros }) {
    await api.getComParametros('relatorio/' + relatorio, { from: data_inicial, to: data_final, ...parametros }).then(
      relatorio => {
        commit(SET_STATE, { relatorio })
      },
    )
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
